import PropTypes from 'prop-types'

export default function LabelHeaderCustom({ children, className = '', other }) {
  return (
    <label
      className={` ${className}`}
      {...other}
      style={{
        fontSize: '16px',
        fontWeight: 700,
        color: ' var(--color-on-base-content-high)',
      }}
    >
      {children}
    </label>
  )
}

LabelHeaderCustom.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  other: PropTypes.any,
}
